<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import { onLogout } from '@/vue-apollo';
    import {AUTH_TOKEN} from "../vue-apollo";
    export default {
        name: 'Logout',
        async mounted() {
            onLogout(this.$apollo.getClient()).then(
                ()=>{
                localStorage.removeItem(`${AUTH_TOKEN}_doc_check` );
                window.close()
            })

        }
    };
</script>

<style scoped>

</style>